import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'redux/store';

export const selectPaymentTerminalsPanelState = createSelector(
  (state: RootState) => state,
  (state: RootState) => state.location.paymentProcessingTab.paymentTerminalsPanel
);
